export default __webpack_public_path__ + "static/media/liveCourseIcon.e267035a.svg";